module.exports = __webpack_public_path__ + "static/media/logo.d3584e4b.png";